// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const ResetPassword = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     password: "",
//     confirmPassword: "",
//   });
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");
//     setLoading(true);

//     if (formData.password !== formData.confirmPassword) {
//       setError("Passwords do not match");
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await axios.patch(
//         `${process.env.REACT_APP_API_BASE_URL}/auth/reset-password/`,
//         {
//           email: localStorage.getItem("reset_email"),
//           otp: localStorage.getItem("reset_otp"),
//           new_password: formData.password,
//           confirm_password: formData.confirmPassword,
//         }
//       );
//       setSuccess(response.data.message);
//       setTimeout(() => navigate("/"), 2000);
//     } catch (err) {
//       setError(err.response?.data?.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center vh-100">
//       <div className="card shadow-lg p-4" style={{ borderRadius: "20px" }}>
//         <div
//           className="card-header text-white text-center"
//           style={{
//             background: "#008cba",
//           }}
//         >
//           <h3 className="fw-bold mb-0 font_header">Reset Your Password</h3>
//         </div>

//         {error && <div className="alert alert-danger mt-2">{error}</div>}
//         {success && <div className="alert alert-success mt-2">{success}</div>}
//         <form onSubmit={handleSubmit}>
//           <div className="mt-2 mb-3 position-relative">
//             <label className="form-label fw-semibold">New Password</label>
//             <div className="input-group">
//               <span className="input-group-text bg-light">
//                 <i className="fas fa-lock text-info"></i>
//               </span>
//               <input
//                 type="password"
//                 className="form-control"
//                 name="password"
//                 placeholder="Enter new password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>
//           <div className="mb-3 position-relative">
//             <label className="form-label fw-semibold">Confirm Password</label>
//             <div className="input-group">
//               <span className="input-group-text bg-light">
//                 <i className="fas fa-lock text-info"></i>
//               </span>
//               <input
//                 type="password"
//                 className="form-control"
//                 name="confirmPassword"
//                 placeholder="Confirm new password"
//                 value={formData.confirmPassword}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>
//           <button
//             type="submit"
//             className="btn btn-outline-info w-100 fw-bold py-2 shadow-sm"
//             disabled={loading}
//           >
//             {loading ? "Resetting..." : "Reset Password"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/auth/reset-password/`,
        {
          email: formData.email,
          otp_code: formData.otp,
          new_password: formData.password,
          confirm_password: formData.confirmPassword,
        }
      );

      setSuccess(response.data.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <div className="row d-flex justify-content-center align-items-center h-100">
        <div className="col-12 col-md-8 col-lg-5 col-xl-5">
          <div className="card shadow-lg p-4" style={{ borderRadius: "20px" }}>
            <div
              className="card-header text-white text-center"
              style={{ background: "#008cba" }}
            >
              <h3 className="fw-bold mb-0">Reset Your Password</h3>
            </div>

            {error && <div className="alert alert-danger mt-2">{error}</div>}
            {success && (
              <div className="alert alert-success mt-2">{success}</div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Email Field */}
              <div className="mt-2 mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fas fa-envelope text-info"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* OTP Field */}
              <div className="mb-3">
                <label className="form-label fw-semibold">OTP</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fas fa-key text-info"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="otp"
                    placeholder="Enter OTP"
                    value={formData.otp}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* New Password Field */}
              <div className="mb-3">
                <label className="form-label fw-semibold">New Password</label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fas fa-lock text-info"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Enter new password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Confirm Password
                </label>
                <div className="input-group">
                  <span className="input-group-text bg-light">
                    <i className="fas fa-lock text-info"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    placeholder="Confirm new password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-outline-info w-100 fw-bold py-2 shadow-sm"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
